import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  Wrapper,
  Header,
  Card,
  CardCol,
  Body,
  TabBar,
  Tab,
  InfoBox,
  ContentCard,
  ContentCardDetails,
  HistorySection,
  HistoryRow,
  HistoryRowMain
} from './ShimmerRewards.styles';
import { skeletonProps } from '../Shimmer.types';

export const ShimmerRewards: React.FC = () => (
  <Wrapper>
    <Header>
      <Skeleton {...skeletonProps} width={200} height={28} />
    </Header>

    <Card>
      <CardCol>
        <Skeleton {...skeletonProps} width={80} height={22} borderRadius={12} />
        <Skeleton {...skeletonProps} width={60} height={16} />
        <Skeleton {...skeletonProps} width={120} height={26} />
      </CardCol>
      <CardCol>
        <Skeleton {...skeletonProps} width={80} height={22} borderRadius={12} />
        <Skeleton {...skeletonProps} width={60} height={16} />
        <Skeleton {...skeletonProps} width={100} height={26} />
        <Skeleton {...skeletonProps} width={90} height={14} />
      </CardCol>
    </Card>

    <Body>
      <TabBar>
        <Tab>
          <Skeleton {...skeletonProps} height={44} />
        </Tab>
        <Tab>
          <Skeleton {...skeletonProps} height={44} />
        </Tab>
      </TabBar>

      <InfoBox>
        <Skeleton {...skeletonProps} height={16} />
        <Skeleton {...skeletonProps} height={16} width="80%" />
      </InfoBox>

      <ContentCard>
        <Skeleton {...skeletonProps} width={56} height={56} borderRadius={8} />
        <ContentCardDetails>
          <Skeleton {...skeletonProps} height={18} width="60%" />
          <Skeleton {...skeletonProps} height={14} width="40%" />
          <Skeleton {...skeletonProps} height={14} width="50%" />
        </ContentCardDetails>
      </ContentCard>

      <ContentCard>
        <Skeleton {...skeletonProps} width={56} height={56} borderRadius={8} />
        <ContentCardDetails>
          <Skeleton {...skeletonProps} height={18} width="55%" />
          <Skeleton {...skeletonProps} height={14} width="35%" />
        </ContentCardDetails>
      </ContentCard>

      <HistorySection>
        <Skeleton {...skeletonProps} height={22} width={180} style={{ marginBottom: 16 }} />
        {[1, 2, 3].map((i) => (
          <HistoryRow key={i}>
            <HistoryRowMain>
              <Skeleton {...skeletonProps} height={16} width="70%" />
              <Skeleton {...skeletonProps} height={12} width="45%" />
            </HistoryRowMain>
            <Skeleton {...skeletonProps} width={60} height={16} />
            <Skeleton {...skeletonProps} width={70} height={16} />
          </HistoryRow>
        ))}
      </HistorySection>
    </Body>
  </Wrapper>
);
